import React, { useEffect, useMemo, useState } from "react";
import Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import "highcharts/highcharts-more";
import "highcharts/modules/exporting";
import { getChartColor } from "../../config/colors";


const AverageTime = ({ averageTimeData }) => {
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    if (averageTimeData && averageTimeData.length > 0) {
      const formattedData = averageTimeData.map((item) => ({
        category: item.class_name,
        value: parseFloat(item.average_processing_time_minutes || 0),
        color: getChartColor(item.class_name), // Use the centralized function
      }));
      setChartData(formattedData);
    } else {
      setChartData([]);
    }
  }, [averageTimeData]);

  const options = useMemo(() => ({
    chart: {
      type: "column",
      height: 220,
    },
    title: {
      text: null,
    },
    exporting: {
      enabled: false,
    },
    xAxis: {
      categories: chartData.map((item) => item.category),
      title: {
        text: "Class",
      },
    },
    yAxis: {
      title: {
        text: "Mins",
      },
      gridLineDashStyle: "Dash",
      gridLineWidth: 1,
      gridLineColor: "#e0e0e0",
      lineWidth: 1,
      lineColor: "#e0e0e0",
    },
    tooltip: {
      enabled: true,
      formatter: function () {
        return `<b>Class ${this.point.category}</b><br/>Average Time: ${this.y} mins`;
      },
    },
    credits: {
      enabled: false,
    },
    legend: {
      enabled: false,
    },
    plotOptions: {
      column: {
        borderWidth: 0,
        borderRadius: 5,
        groupPadding: 0.1,
        pointPadding: 0.1,
        colorByPoint: true, // ✅ Allow individual colors
      },
    },
    series: [
      {
        data: chartData.map((item) => ({
          y: item.value,
          color: item.color,
           
        })),
      },
    ],
  }), [chartData]);

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default AverageTime;